"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bootstrap_1 = require("bootstrap");
var constants_1 = require("../data/constants");
var Flashmessage = /** @class */ (function () {
    function Flashmessage() {
        this.flashmessage = document.querySelector("[".concat(constants_1.DATA_FLASHMESSAGE, "]"));
        this.flashmessageClose = document.querySelector("[".concat(constants_1.DATA_FLASHMESSAGE_CLOSE, "]"));
        if (!this.flashmessage) {
            return;
        }
        // Get the unique timestamp of the modal
        var flashId = this.flashmessage.dataset.flashmessageId;
        // Clear all old flashmessage cookies but keep the current one
        Flashmessage.clearOldFlashmessageCookies(flashId);
        // If cookie is already set, don't show the modal
        if (Flashmessage.isDismissed(flashId)) {
            return;
        }
        // Show the modal initially
        var modal = new bootstrap_1.Modal(this.flashmessage);
        modal.show();
        // Handle modal close via BS event
        this.flashmessage.addEventListener('hidden.bs.modal', function () {
            Flashmessage.setDismissed(flashId);
        });
        // Handle close modal via button click and also set cookie
        this.flashmessageClose.addEventListener('click', function () {
            Flashmessage.setDismissed(flashId);
            modal.hide();
        });
    }
    // Check if modal should be shown
    Flashmessage.isDismissed = function (flashId) {
        return document.cookie.includes("flashmessage_dismissed_".concat(flashId, "=true"));
    };
    // Set the dismissal cookie (valid for 2 years)
    Flashmessage.setDismissed = function (flashId) {
        var years = 2;
        var expires = new Date(Date.now() + years * 365 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = "flashmessage_dismissed_".concat(flashId, "=true; expires=").concat(expires, "; path=/");
    };
    // Delete old flashmessage cookies
    Flashmessage.clearOldFlashmessageCookies = function (currentFlashId) {
        var cookies = document.cookie.split(';');
        cookies.forEach(function (cookie) {
            var rawName = cookie.trim().split('=')[0];
            // Delete only cookies that are NOT the current flashId
            if (rawName.startsWith('flashmessage_dismissed_') &&
                rawName !== "flashmessage_dismissed_".concat(currentFlashId)) {
                document.cookie = "".concat(rawName, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/");
            }
        });
    };
    return Flashmessage;
}());
exports.default = Flashmessage;
